<template>
  <div class="col-lg-4 col-md-6 col-sm-10 mb-3">
    <div :class="this.class" :style="customStyles" class="rounded h-100 p-5 hover-highlight">
      <router-link v-if="routeTo != null" :to="routeTo" class="row" style="text-decoration: none">
        <div class="col-md-4 d-flex justify-content-center align-items-center">
          <i :class="fontAwesomeIconClass" style="height: 36px; color: white;"></i>
        </div>
        <div class="col-md-8">
          <div class="rew">
            <div class="col-md-12">
              <h2 class="text-white">{{ name }}</h2>
            </div>
            <div class="col-md-12">
              <h3 class="text-white">{{ count }}</h3>
            </div>
          </div>
        </div>
      </router-link>
      <a v-else :href="href" class="row" style="cursor: pointer; text-decoration: none" target="_blank">
        <div class="col-md-4 d-flex justify-content-center align-items-center">
          <i :class="fontAwesomeIconClass" style="height: 36px; color: white"></i>
        </div>
        <div class="col-md-8">
          <div class="rew">
            <div class="col-md-12">
              <h2 class="text-white">{{ name }}</h2>
            </div>
            <div class="col-md-12">
              <h3 class="text-white">{{ count }}</h3>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeWidget',
  props: ['routeTo', 'class', 'fontAwesomeIconClass', 'name', 'count', 'customStyles', 'href'],
}
</script>

<style scoped>
.hover-highlight {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease-in-out;
}

.hover-highlight:hover {
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.6);
}
</style>